if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        const changedOptionPosition = event.target.closest('[data-option-position]')?.dataset.optionPosition;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl, { changedOptionPosition }),
        });
      }

        resetProductFormState() {
            const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariantElement = productInfoNode.querySelectorAll('variant-selects [data-selected-variant]');
        for (let element of selectedVariantElement) {
            if (element.innerHTML.trim()) {
                return JSON.parse(element.innerHTML);
            }
        }
        return null;
    }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html, event) {
        console.log('Event from Liquid:', event);
        const variantSelects = html.querySelectorAll('variant-selects');
        if (variantSelects.length) {
            this.querySelectorAll('variant-selects').forEach((variantSelect, index) => {
                if (variantSelects[index]) {
                    HTMLUpdateUtility.viewTransition(variantSelect, variantSelects[index], this.preProcessHtmlCallbacks);
                }
            });
        }

        const changedOptionPosition = parseInt(event?.changedOptionPosition, 10);
        if (!isNaN(changedOptionPosition)) {
          this.querySelectorAll('fieldset[data-option-position]').forEach((fieldset) => {
            const fieldsetPosition = parseInt(fieldset.dataset.optionPosition, 10);
            if (fieldsetPosition > changedOptionPosition) {
              fieldset.querySelectorAll('input[type="radio"]').forEach((radio) => {
                radio.checked = false;
              });

              const detailsElement = fieldset.closest('details');
              const selectedValueSpans = detailsElement?.querySelectorAll('[data-selected-value]');
              if (selectedValueSpans && selectedValueSpans.length > 0) {
                selectedValueSpans.forEach((selectedValueSpan) => {
                  selectedValueSpan.textContent = '';
                });
                const checkmark = detailsElement?.querySelector('.product-variant-picker--loop-checkmark');
                const stepCount = detailsElement?.querySelector('.product-variant-picker--loop-step-count');
                if (detailsElement) {
                  //open it! 
                  detailsElement.open = true;
                }
                if (checkmark) {
                  checkmark.classList.add('hidden');
                }
                if (stepCount) {
                  stepCount.classList.remove('hidden');
                }
              }
            }
          });
        }
    }

      handleUpdateProductInfo(productUrl, event) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          const addonSnapshot = this.snapshotSelectedAddons();
          const openStepsSnapshot = this.snapshotOpenSteps();

          this.updateOptionValues(html, event);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          
          // Update the product bundle if it exists
          this.updateProductBundle(variant);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            } else if (!source && destination && id === 'set-upgrade') {
              destination.innerHTML = '';
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('addon-product');
          updateSourceFromDestination('set-upgrade');
          updateSourceFromDestination('options');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('sticky');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.syncSetUpgradeVisibility();
          this.restoreSelectedAddons(addonSnapshot);

          // Keep the open accordion step when upgrading via set-upgrade (no option position change).
          // Normal option changes already manage open state in updateOptionValues.
          if (!event?.changedOptionPosition) {
            this.restoreOpenSteps(openStepsSnapshot);
          }

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      syncSetUpgradeVisibility() {
        const wrapper = this.querySelector(`#set-upgrade-${this.dataset.section}`);
        if (!wrapper) return;

        const materiaalFieldset = this.querySelector('fieldset[data-option-position="2"]');
        if (!materiaalFieldset) return;

        if (!materiaalFieldset.querySelector('input:checked')) {
          wrapper.innerHTML = '';
        }
      }

      snapshotOpenSteps() {
        const openAddonTypes = Array.from(
          this.querySelectorAll('addon-product details.product-variant-picker__option[open]')
        )
          .map((details) => details.querySelector('input[type="radio"]')?.dataset.addonType)
          .filter(Boolean);

        const openOptionPositions = Array.from(
          this.querySelectorAll('variant-selects details.product-variant-picker__option[open]')
        )
          .map((details) => details.querySelector('fieldset[data-option-position]')?.dataset.optionPosition)
          .filter(Boolean);

        return { openAddonTypes, openOptionPositions };
      }

      restoreOpenSteps({ openAddonTypes = [], openOptionPositions = [] } = {}) {
        this.querySelectorAll('addon-product details.product-variant-picker__option').forEach((details) => {
          const type = details.querySelector('input[type="radio"]')?.dataset.addonType;
          if (type && openAddonTypes.includes(type)) {
            details.setAttribute('open', '');
          } else {
            details.removeAttribute('open');
          }
        });

        this.querySelectorAll('variant-selects details.product-variant-picker__option').forEach((details) => {
          const position = details.querySelector('fieldset[data-option-position]')?.dataset.optionPosition;
          if (position && openOptionPositions.includes(position)) {
            details.setAttribute('open', '');
          } else {
            details.removeAttribute('open');
          }
        });
      }

      snapshotSelectedAddons() {
        const addonProduct = this.querySelector('addon-product');
        if (!addonProduct) return [];

        return Array.from(addonProduct.querySelectorAll('input[type="radio"]:checked')).map((input) => ({
          type: input.dataset.addonTypeHandle || input.dataset.addonType,
          sku: input.dataset.addonSku,
          titleHandle: input.dataset.addonTitleHandle,
        }));
      }

      restoreSelectedAddons(snapshot) {
        if (!snapshot?.length) return;

        const addonProduct = this.querySelector('addon-product');
        if (!addonProduct) return;

        let restored = false;

        snapshot.forEach(({ type, sku, titleHandle }) => {
          if (!type) return;

          const candidates = Array.from(addonProduct.querySelectorAll('input[type="radio"]')).filter((input) => {
            const inputType = input.dataset.addonTypeHandle || input.dataset.addonType;
            return inputType === type;
          });

          if (!candidates.length) return;

          const match =
            (sku && candidates.find((input) => input.dataset.addonSku === sku)) ||
            (titleHandle && candidates.find((input) => input.dataset.addonTitleHandle === titleHandle));

          if (!match) return;

          match.checked = true;
          restored = true;

          const detailsElement = match.closest('details');
          if (!detailsElement) return;

          detailsElement.classList.add('option-selected');
          detailsElement.classList.remove('product-variant-picker__option--required');

          const warning = detailsElement.querySelector('[data-addon-warning]');
          if (warning) warning.hidden = true;

          const label = addonProduct.querySelector(`label[for="${match.id}"]`);
          const titleText = label?.querySelector('.swatch-input__label-info-text')?.textContent.trim() || '';
          detailsElement.querySelectorAll('[data-selected-value]').forEach((span) => {
            span.textContent = titleText;
          });
        });

        if (!restored) return;

        if (addonProduct.form) {
          addonProduct.form.hasAddons = addonProduct.querySelectorAll('input[type="radio"]:checked').length > 0;
          if (typeof addonProduct.form.updateSubmitButtonState === 'function') {
            addonProduct.form.updateSubmitButtonState();
          }
        }

        if (typeof addonProduct.updatePrice === 'function') {
          addonProduct.updatePrice();
        }
      }

      updateProductBundle(variant) {
        if (!variant) return;
        
        // Find the product bundle element within this product info
        const productBundle = this.querySelector('product-bundle');
        if (!productBundle) return;
        
        // Call the updateFromVariant method on the product bundle
        productBundle.updateFromVariant(variant);
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

        setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }


      get variantSelectors() {
        return this.querySelectorAll('variant-selects');
    }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

if (!customElements.get('variant-categories')) {
  customElements.define(
    'variant-categories',
    class VariantCategories extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll('[data-category-button]');
        this.contents = this.querySelectorAll('[data-category-content]');
        
        // Add click handlers to all buttons
        this.buttons.forEach(button => {
          button.addEventListener('click', this.handleButtonClick.bind(this));
        });

        // Show first option by default
        if (this.buttons.length > 0) {
          this.showCategory(this.buttons[0].dataset.categoryButton);
        }
      }

      handleButtonClick(event) {
        const button = event.target.closest('[data-category-button]');
        if (!button) return;

        const categoryId = button.dataset.categoryButton;
        this.showCategory(categoryId);
      }

      showCategory(categoryId) {
        // Update button states
        this.buttons.forEach(button => {
          button.classList.toggle('active', button.dataset.categoryButton === categoryId);
        });

        // Show/hide content
        this.contents.forEach(content => {
          content.classList.toggle('hidden', content.dataset.categoryContent !== categoryId);
        });
      }
    }
  );
}